import { Component } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '../../../pipes/translate.pipe';
import { Router } from '@angular/router';

@Component({
  selector: 'app-success',
  imports: [MatIcon, TranslatePipe],
  templateUrl: './success.component.html',
  styleUrl: './success.component.scss',
})
export class SuccessComponent {
  constructor(private router: Router) {}

  onRedirect() {
    this.router.navigate(['my-reservations']).then(() => {});
  }
}
